export const textConstants = {
  tourNotAvail: "Please select from the following available options:",
  dataNotAvail: "Please select from the following available options:",
  timeNotAvail: "Please select from the following available options:",
  bedroomNotAvail: "Please select from the following available options:",
  budgetNotAvail: "Please select from the following available options:",
  moveInNotAvail: "Please select from the following available options:",
  datesNotAvail: "Please select from the following available options:",
  multiOptNotAvail: "Please select from the following available options:",
};
